module.exports = __webpack_public_path__ + "static/media/blank-profile-picture.543f0ea8.jpg";